import { useCallback } from "react";
import { useFetchPreviewFinancialProgram } from "@perxis-auto/credit-sdk";
import { formatFinancialPrograms } from "@perxis-auto/credit-sdk/lib/internal/entities/credit/lib/formatFinancialPrograms";
import { isDefined } from "@perxis-auto/shared";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../model/index.js";
import { actions } from "../model/slice.js";
function useCreditDataFetch({ vehicleId = "", model, price }) {
  const dispatch = useAppDispatch();
  const [fetchPreviewFinancialProgram] = useFetchPreviewFinancialProgram();
  const fetchCreditData = useCallback(async () => {
    try {
      if (!isDefined(model) || !isDefined(price) || !isDefined(vehicleId)) {
        throw new Error("Виджет АВН. Ошибка, для расчета ежемесячного платежа: необходима цена и название модели");
      }
      const { choice, program } = await fetchPreviewFinancialProgram({
        model,
        price
      });
      const [extFinancialProgram] = formatFinancialPrograms([program], []);
      dispatch(
        actions.setOne({
          vehicleId,
          choice,
          previewProgram: extFinancialProgram,
          isSelected: false
        })
      );
    } catch (e) {
    }
  }, [vehicleId, model, price]);
  return fetchCreditData;
}
export {
  useCreditDataFetch
};
